const ConstantMixin = {
    data() {
        return {
            Role: {
                ADMIN: 'ADMIN',
                OWNER: 'OWNER',
                BRAND_MANAGER: 'BRAND_MANAGER',
                AGENCY: 'AGENCY',
                SALESMAN: 'SALESMAN',
                SHIPPER: 'SHIPPER',
                TELESALES: 'TELESALES',
                WAREHOUSE_KEEPER: 'WAREHOUSE_KEEPER',
                DEBT_ACCOUNTANT: 'DEBT_ACCOUNTANT',
            },
            ExportType: {
                XBH: 'XBH',
                XNB: 'XNB',
                XDC: 'XDC',
                XTL: 'XTL',
                XHH: 'XHH',
                XKK: 'XKK',
            },
            STATUS: {
                PENDING: 'PENDING',
                CONFIRMED: 'CONFIRMED',
                EXPORTED: 'EXPORTED',
                SHIPPING: 'SHIPPING',
                CANCELED: 'CANCELED',
                COMPLETED: 'COMPLETED'
            },
            PO_TYPE: {
                CUSTOMER: "CUSTOMER",
                AGENCY: "AGENCY",
                SALESMAN: "SALESMAN",
            }
        }
    },
};

export default ConstantMixin;